import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";

export default function CustomerOrders() {
  const { slug } = useParams();
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/shop/orders").then((r) => setOrders(r.data)); }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6">Your orders</h1>
      {orders.length === 0 ? (
        <div className="text-center py-16">
          <ShoppingBag className="h-10 w-10 mx-auto text-muted-foreground/40 mb-3" />
          <p className="font-medium">No orders yet</p>
          <Link to={`/store/${slug}`}><Button className="mt-5 rounded-full">Start shopping</Button></Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <Link to={`/store/${slug}/orders/${o.id}`} key={o.id} data-testid={`cust-order-${o.id}`}>
              <Card className="p-4 rounded-xl border-border flex items-center justify-between hover:shadow-sm transition-shadow">
                <div>
                  <p className="font-medium">{o.order_number}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{new Date(o.created_at).toLocaleDateString()} · {o.items.length} item{o.items.length > 1 ? "s" : ""}</p>
                </div>
                <div className="flex items-center gap-3">
                  <StatusBadge status={o.status} />
                  <span className="font-semibold">{money(o.total)}</span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
